import { Injectable } from "@angular/core";
import { Protocol } from "../interfaces/protocols/protocol";
import { Subject } from "rxjs";
import { Pathway } from "../modules/pathways/entities/pathway";

@Injectable({
	providedIn: "root",
})
export class ToolbarServiceService {
	protocolSubject = new Subject<Protocol>();
	pathwaySubject = new Subject<Pathway>();

	constructor() {}
}
